import { render, staticRenderFns } from "./ContractReportTabs.vue?vue&type=template&id=87ce0e8a"
import script from "./ContractReportTabs.vue?vue&type=script&lang=js"
export * from "./ContractReportTabs.vue?vue&type=script&lang=js"
import style0 from "./ContractReportTabs.vue?vue&type=style&index=0&id=87ce0e8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports